const hiddenUnits = ['units', 'enum', 'digital'];

export default unit => (hiddenUnits.includes(unit) ? '' : unit);
